// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o7-1";
export var messageSideRight = "_o7-2";
export var subscribeToBackInStockBubbleContainer = "_o7-0";